import {SessionParticipantReviewFile} from './SessionParticipantReviewFile';

export class SessionParticipantReview implements ISessionParticipantReview {
    id?: string;
    accountId?: string;
    sessionParticipantId?: string;
    dateCreated?: Date;
    dateUpdated?: Date;
    dateLastViewed?: Date | undefined;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    introduction?: string | undefined;
    additionalNotes?: string | undefined;
    reviewFiles?: SessionParticipantReviewFile[] | undefined;

    constructor(data?: ISessionParticipantReview) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.accountId = _data['accountId'];
            this.sessionParticipantId = _data['sessionParticipantId'];
            this.dateCreated = _data['dateCreated'] ? new Date(_data['dateCreated'].toString()) : <any>undefined;
            this.dateUpdated = _data['dateUpdated'] ? new Date(_data['dateUpdated'].toString()) : <any>undefined;
            this.dateLastViewed = _data['dateLastViewed'] ? new Date(_data['dateLastViewed'].toString()) : <any>undefined;
            this.createdByPersonId = _data['createdByPersonId'];
            this.updatedByPersonId = _data['updatedByPersonId'];
            this.introduction = _data['introduction'];
            this.additionalNotes = _data['additionalNotes'];
            if (Array.isArray(_data['reviewFiles'])) {
                this.reviewFiles = [] as any;
                for (const item of _data['reviewFiles'])
                    this.reviewFiles!.push(SessionParticipantReviewFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SessionParticipantReview {
        data = typeof data === 'object' ? data : {};
        const result = new SessionParticipantReview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['accountId'] = this.accountId;
        data['sessionParticipantId'] = this.sessionParticipantId;
        data['dateCreated'] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data['dateUpdated'] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
        data['dateLastViewed'] = this.dateLastViewed ? this.dateLastViewed.toISOString() : <any>undefined;
        data['createdByPersonId'] = this.createdByPersonId;
        data['updatedByPersonId'] = this.updatedByPersonId;
        data['introduction'] = this.introduction;
        data['additionalNotes'] = this.additionalNotes;
        if (Array.isArray(this.reviewFiles)) {
            data['reviewFiles'] = [];
            for (const item of this.reviewFiles)
                data['reviewFiles'].push(item.toJSON());
        }
        return data;
    }
}

export interface ISessionParticipantReview {
    id?: string;
    accountId?: string;
    sessionParticipantId?: string;
    dateCreated?: Date;
    dateUpdated?: Date;
    dateLastViewed?: Date | undefined;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    introduction?: string | undefined;
    additionalNotes?: string | undefined;
    reviewFiles?: SessionParticipantReviewFile[] | undefined;
}